'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'utensils';
var width = 448;
var height = 512;
var aliases = [127860,61685,"cutlery"];
var unicode = 'f2e7';
var svgPathData = 'M190.8 0L174.6 0l1.6 9.3s0 0 0 0l23.1 138.8c.5 3 .8 6.1 .8 9.2l0 10.7c0 30.9-25.1 56-56 56l-64 0c-30.9 0-56-25.1-56-56l0-10.7c0-3.1 .3-6.2 .8-9.2L35.9 81.3l6-36 6-36s0 0 0 0L49.4 0 33.2 0 32.1 6.7s0 0 0 0l-6 36-6 36L9 145.5c-.7 3.9-1 7.9-1 11.8L8 168c0 39.8 32.2 72 72 72l24 0 0 264 0 8 16 0 0-8 0-264 24 0c39.8 0 72-32.2 72-72l0-10.7c0-4-.3-7.9-1-11.8L191.9 6.7s0 0 0 0L190.8 0zM143.6 0l-16 0 .4 8.4 8 160 .4 7.6 16 0-.4-8.4-8-160L143.6 0zM96.4 0l-16 0L80 7.6l-1 20-1 20-2 40-4 80-.4 8.4 16 0 .4-7.6 4-80 2-40 1-20 1-20L96.4 0zM304 176c0-67.7 24.2-107.4 48.9-130.3c12.5-11.6 25.5-19.2 36-23.8c5.3-2.3 9.9-3.8 13.4-4.8c3.7-1 5.6-1.1 5.7-1.1c0 0 0 0 0 0l8 0 0 320-112 0 0-160zM432 336l0-320 0-16L416 0l-8 0C392 0 288 32 288 176l0 160 0 16 16 0 112 0 0 152 0 8 16 0 0-8 0-152 0-8 0-8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUtensils = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;